export const ApiNameList = {
  restApi: {
    baseUrl: '/',
    // baseUrl: 'http://localhost:8080/',
    login: 'public/api/asa/user/login',
    refreshToken: 'secure/api/asa/user/refreshToken',
    forgotPassword: 'public/api/asa/user/forgotPassword',
    resetGibberish: 'public/api/asa/user/resetPassword',
    universityLandingAPI: 'secure/api/asa/university/landing',
    logout: 'public/api/asa/user/logout',
    getStudentsSummary: 'secure/api/asa/university/getStudentsSummary',
    updateEnrollmentStatus: 'secure/api/asa/university/updateEnrollmentStatus',
    updateRosterRecords: 'secure/api/asa/university/updateRosterRecords',
    downloadEnrollmentRecords: 'secure/api/asa/university/downloadEnrollmentRecords',
    getDependentReport: 'secure/api/asa/university/getDependentReport',
    studentInfo: 'secure/api/asa/university/studentInfo',
    getFiles: 'secure/api/asa/university/getFiles',
    downloadFile: 'secure/api/asa/university/downloadFile',
    getStudentEnrollments: 'secure/api/asa/university/enrollments',
    enrollmentHistory: 'secure/api/asa/university/getEnrollHistory',
    getViewStudentDetials: 'secure/api/asa/university/getViewStudentDetials',
    updateStudentDetails: 'secure/api/asa/university/updateStudentDetails',
    getConfigData: 'secure/api/asa/university/getConfigData',
    downloadReceipt: 'secure/api/asa/university/getEnrollReceipt',
    getUserAccount: 'secure/api/asa/student/getUserAccount',
    changePassword: 'secure/api/asa/user/changePassword',
    retrieveNotes: 'secure/api/asa/university/retrieveNotes',
    getSpecialEnrollmentsDropdownData: 'secure/api/asa/university/getSpecialEnrollmentsDropdownData',
    saveSpecialEnrollmentsOptions: 'secure/api/asa/university/saveSpecialEnrollmentsOptions',
    delereOrSaveNotes: 'secure/api/asa/university/delereOrSaveNotes',
    getWaiverReport: 'secure/api/asa/university/getWaiverReport',
    getWaiverDeniedReport: 'secure/api/asa/university/getWaiverDeniedReport',
    updateDependent: 'secure/api/asa/common/updateDependent',
    getStudentAndDependentSummary: 'secure/api/asa/university/getStudentAndDependentSummary',
    getStatusFilters: 'secure/api/asa/university/getStatusFilters',
    downloadEnrollmentRecordsForStudentAndDependents: 'secure/api/asa/university/downloadEnrollmentRecordsForStudentAndDependents',
    sendBulkMail: 'secure/api/asa/university/sendBulkMail',
    getUserId: 'public/api/asa/user/verify',
    authorizeOkta: 'secure/api/asa/user/authorizeOkta',
    getOktaUserId:'public/api/asa/common/getOktaUserId',
    getOktaGroups:'public/api/asa/common/getOktaGroups',
    getOktaMfaFactors:'public/api/asa/common/getOktaMfaFactors',
    getOktaMfaSendOtp:'public/api/asa/common/getOktaMfaSendOtp',
    getOktaMfaVerifyOtp:'public/api/asa/common/getOktaMfaVerifyOtp',
    resetOktaPassword:'public/api/asa/common/resetOktaUserPassword',
    changePasswordOkta:'secure/api/asa/common/changeOktaPassword'
  }
};
